import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { clearCartDataFromCache } from "@magento/peregrine/lib/Apollo/clearCartDataFromCache";
import BrowserPersistence from "@magento/peregrine/lib/util/simplePersistence";
import { signOut } from "@magento/peregrine/lib/store/actions/user";
import { reset } from "../bookTable";
import actions from "./actions";
import { clearCustomerDataFromCache } from "@magento/peregrine/lib/Apollo/clearCustomerDataFromCache";
import { clearCheckoutDataFromStorage } from "../checkout";
import { resetBook_a_Table } from "../../../../../redux/bookTable/BookTable.actions";
import * as Sentry from "@sentry/react";
var storage = new BrowserPersistence();
export var submitOutOfStockClean = payload => ( /*#__PURE__*/function () {
  var _thunk = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.outOfStockClean.receive(payload));
  });
  function thunk(_x) {
    return _thunk.apply(this, arguments);
  }
  return thunk;
}());
export var createCart = payload => ( /*#__PURE__*/function () {
  var _thunk2 = _asyncToGenerator(function* (dispatch, getState) {
    var {
      fetchCartId
    } = payload;
    var {
      cart
    } = getState();

    // if a cart already exists in the store, exit
    if (cart.cartId) {
      return;
    }

    // Request a new cart.
    dispatch(actions.getCart.request());

    // if a cart exists in storage, act like we just received it
    var cartId = yield retrieveCartId();
    if (cartId) {
      dispatch(actions.getCart.receive(cartId));
      return;
    }
    try {
      // errors can come from graphql and are not thrown
      var {
        data,
        errors
      } = yield fetchCartId({
        fetchPolicy: "no-cache"
      });
      var receivePayload;
      if (errors) {
        receivePayload = new Error(errors);
      } else {
        receivePayload = data.cartId;
        // write to storage in the background
        saveCartId(data.cartId);
      }
      dispatch(actions.getCart.receive(receivePayload));
    } catch (error) {
      // If we are unable to create a cart, the cart can't function, so
      // we forcibly throw so the upstream actions won't retry.
      dispatch(actions.getCart.receive(error));
      throw new Error("Unable to create cart");
    }
  });
  function thunk(_x2, _x3) {
    return _thunk2.apply(this, arguments);
  }
  return thunk;
}());
export var updateCartData = details => ( /*#__PURE__*/function () {
  var _thunk3 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.getDetails.receive({
      details
    }));
  });
  function thunk(_x4) {
    return _thunk3.apply(this, arguments);
  }
  return thunk;
}());
export var setIsLoadingCart = () => ( /*#__PURE__*/function () {
  var _thunk4 = _asyncToGenerator(function* (dispatch, getState) {
    var {
      cart
    } = getState();
    dispatch(actions.getDetails.request(cart));
  });
  function thunk(_x5, _x6) {
    return _thunk4.apply(this, arguments);
  }
  return thunk;
}());
export var addItemToCart = function () {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var {
    addItemMutation,
    cartItems
  } = payload;
  return /*#__PURE__*/function () {
    var _thunk5 = _asyncToGenerator(function* (dispatch, getState) {
      dispatch(actions.addItem.request(payload));
      try {
        yield addItemMutation();
        dispatch(actions.addItem.receive());
      } catch (error) {
        dispatch(actions.addItem.receive(error));
      }
    });
    function thunk(_x7, _x8) {
      return _thunk5.apply(this, arguments);
    }
    return thunk;
  }();
};

/**
 * Applies changes in options/quantity to a cart item.
 *
 * @param payload.cartItemId {Number} the id of the cart item we are updating
 * @param payload.item {Object} the new configuration item if changes are selected.
 * @param payload.quantity {Number} the quantity of the item being updated
 * @param payload.productType {String} 'ConfigurableProduct' or other.
 */
export var updateItemInCart = function () {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var {
    cartItemId,
    fetchCartDetails,
    fetchCartId,
    item,
    productType,
    quantity,
    removeItem,
    updateItem
  } = payload;
  return /*#__PURE__*/function () {
    var _thunk6 = _asyncToGenerator(function* (dispatch, getState) {
      dispatch(actions.updateItem.request(payload));
      var {
        cart,
        user
      } = getState();
      var {
        cartId
      } = cart;
      var {
        isSignedIn
      } = user;
      try {
        if (productType === "ConfigurableProduct") {
          // You _must_ remove before adding or risk deleting the item
          // entirely if only quantity has been modified.
          yield dispatch(removeItemFromCart({
            item: {
              id: cartItemId
            },
            fetchCartDetails,
            fetchCartId,
            removeItem
          }));
          yield dispatch(addItemToCart(_objectSpread({}, payload)));
        } else {
          // If the product is a simple product we can just use the
          // updateCartItems graphql mutation.
          yield updateItem({
            variables: {
              cartId,
              itemId: cartItemId,
              quantity
            }
          });
          // The configurable product conditional dispatches actions that
          // each call getCartDetails. For simple items we must request
          // details after the mutation completes. This may change when
          // we migrate to the `cart` query for details, away from REST.
          yield dispatch(getCartDetails({
            fetchCartId,
            fetchCartDetails
          }));
        }
        dispatch(actions.updateItem.receive());
      } catch (error) {
        dispatch(actions.updateItem.receive(error));
        var shouldRetry = !error.networkError && isInvalidCart(error);
        if (shouldRetry) {
          // Delete the cached ID from local storage and Redux.
          // In contrast to the save, make sure storage deletion is
          // complete before dispatching the error--you don't want an
          // upstream action to try and reuse the known-bad ID.
          yield dispatch(removeCart());

          // then create a new one
          try {
            yield dispatch(createCart({
              fetchCartId
            }));
          } catch (error) {
            // If creating a cart fails, all is not lost. Return so that the
            // user can continue to at least browse the site.
            return;
          }

          // and fetch details
          yield dispatch(getCartDetails({
            fetchCartId,
            fetchCartDetails
          }));
          if (isSignedIn) {
            // The user is signed in and we just received their cart.
            // Retry this operation.
            return thunk(...arguments);
          } else {
            // The user is a guest and just received a brand new (empty) cart.
            // Add the updated item to that cart.
            yield dispatch(addItemToCart(_objectSpread({}, payload)));
          }
        }
      }
    });
    function thunk(_x9, _x10) {
      return _thunk6.apply(this, arguments);
    }
    return thunk;
  }();
};
export var removeItemFromCart = payload => {
  var {
    item,
    fetchCartDetails,
    fetchCartId,
    removeItem
  } = payload;
  return /*#__PURE__*/function () {
    var _thunk7 = _asyncToGenerator(function* (dispatch, getState) {
      dispatch(actions.removeItem.request(payload));
      var {
        cart
      } = getState();
      var {
        cartId
      } = cart;
      try {
        yield removeItem({
          variables: {
            cartId,
            itemId: item.id
          }
        });
        dispatch(actions.removeItem.receive());
      } catch (error) {
        dispatch(actions.removeItem.receive(error));
        var shouldResetCart = !error.networkError && isInvalidCart(error);
        if (shouldResetCart) {
          // Delete the cached ID from local storage.
          // The reducer handles clearing out the bad ID from Redux.
          // In contrast to the save, make sure storage deletion is
          // complete before dispatching the error--you don't want an
          // upstream action to try and reuse the known-bad ID.
          yield dispatch(removeCart());
          // then create a new one
          try {
            yield dispatch(createCart({
              fetchCartId
            }));
          } catch (error) {
            // If creating a cart fails, all is not lost. Return so that the
            // user can continue to at least browse the site.
            return;
          }
        }
      }
      yield dispatch(getCartDetails({
        fetchCartId,
        fetchCartDetails
      }));
    });
    function thunk(_x11, _x12) {
      return _thunk7.apply(this, arguments);
    }
    return thunk;
  }();
};
export var setIsMiniCartOpen = payload => ( /*#__PURE__*/function () {
  var _thunk8 = _asyncToGenerator(function* (dispatch, getState) {
    dispatch(actions.setIsMiniCartOpen.recieve(payload));
  });
  function thunk(_x13, _x14) {
    return _thunk8.apply(this, arguments);
  }
  return thunk;
}());
export var getCartDetails = payload => {
  var {
    apolloClient,
    fetchCartId,
    fetchCartDetails
  } = payload;
  return /*#__PURE__*/function () {
    var _thunk9 = _asyncToGenerator(function* (dispatch, getState) {
      var {
        cart,
        user
      } = getState();
      var {
        cartId
      } = cart;
      var {
        isSignedIn
      } = user;

      // if there isn't a cart, create one then retry this operation
      if (!cartId) {
        try {
          yield dispatch(createCart({
            fetchCartId
          }));
        } catch (error) {
          // If creating a cart fails, all is not lost. Return so that the
          // user can continue to at least browse the site.
          Sentry.addBreadcrumb({
            category: "cart",
            message: "createCart() failed",
            data: {
              error: error
            }
          });
          Sentry.captureMessage("createCart() failed", "error");
          return;
        }
        return thunk(...arguments);
      }

      // Once we have the cart id indicate that we are starting to make
      // async requests for the details.
      dispatch(actions.getDetails.request(cartId));
      try {
        var {
          data
        } = yield fetchCartDetails({
          variables: {
            cartId
          },
          skip: !cartId,
          fetchPolicy: "no-cache"
        });
        var {
          cart: details
        } = data;
        dispatch(actions.getDetails.receive({
          details
        }));
      } catch (error) {
        dispatch(actions.getDetails.receive(error));
        var shouldResetCart = !error.networkError && isInvalidCart(error);
        if (shouldResetCart) {
          Sentry.captureMessage("Should reset cart", "warning");

          // Delete the cached ID from local storage.
          yield dispatch(removeCart());
          yield dispatch(resetBook_a_Table());

          // Clear the cart data from apollo client if we get here and
          // have an apolloClient.
          if (apolloClient) {
            yield clearCartDataFromCache(apolloClient);
            yield clearCustomerDataFromCache(apolloClient);
            yield clearCheckoutDataFromStorage();
          }

          // Create a new one
          try {
            yield dispatch(() => {
              createCart({
                fetchCartId
              });
            });
          } catch (error) {
            // If creating a cart fails, all is not lost. Return so that the
            // user can continue to at least browse the site.
            return;
          }

          // Retry this operation
          return thunk(...arguments);
        }
      }
    });
    function thunk(_x15, _x16) {
      return _thunk9.apply(this, arguments);
    }
    return thunk;
  }();
};
export var removeCart = () => ( /*#__PURE__*/function () {
  var _thunk10 = _asyncToGenerator(function* (dispatch) {
    // Clear the cartId from local storage.
    yield clearCartId();

    // Clear the cart info from the redux store.
    dispatch(actions.reset());
  });
  function thunk(_x17) {
    return _thunk10.apply(this, arguments);
  }
  return thunk;
}());

/* helpers */
export function retrieveCartId() {
  return _retrieveCartId.apply(this, arguments);
}
function _retrieveCartId() {
  _retrieveCartId = _asyncToGenerator(function* () {
    return storage.getItem("cartId");
  });
  return _retrieveCartId.apply(this, arguments);
}
export function saveCartId(_x18) {
  return _saveCartId.apply(this, arguments);
}
function _saveCartId() {
  _saveCartId = _asyncToGenerator(function* (id) {
    return storage.setItem("cartId", id);
  });
  return _saveCartId.apply(this, arguments);
}
export function clearCartId() {
  return _clearCartId.apply(this, arguments);
}

// Returns true if the cart is invalid.
function _clearCartId() {
  _clearCartId = _asyncToGenerator(function* () {
    storage.removeItem("cartId");
    var cartId = storage.getItem("cartId");
    if (cartId) {
      Sentry.addBreadcrumb({
        category: "cart",
        message: "clearCartId finished executing",
        level: "debug",
        data: {
          result: cartId
        }
      });
      Sentry.captureMessage("Failed to clear cartId", "error");
    }
  });
  return _clearCartId.apply(this, arguments);
}
function isInvalidCart(error) {
  return !!(error.graphQLErrors && error.graphQLErrors.find(err => err.message.includes("Could not find a cart") || err.message.includes("The cart isn't active") || err.message.includes("The current user cannot perform operations on cart") || err.message.includes("Can't assign cart to store in different website.")));
}